module.exports = __webpack_public_path__ + "img/bg.478e6114.jpg";